import { MixpanelPolicyPayload } from './generic-entity-types';

export interface PolicyCancelledPayload extends MixpanelPolicyPayload {
  reason?: string;
}

export function generatePolicyCancelledProperties(payload: PolicyCancelledPayload): PolicyCancelledPayload {
  return payload;
}
